import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkIdDirective } from './link-id.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LinkIdDirective
    ],
    providers: [],
    exports: [
        LinkIdDirective
    ]
})
export class LinkIdDirectiveModule {}
